module.exports = __webpack_public_path__ + "img/app_9.a470cafd.jpg";